import { render } from "./MoreInfoCard.vue?vue&type=template&id=6a31364c"
import script from "./MoreInfoCard.vue?vue&type=script&lang=js"
export * from "./MoreInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__